(function () {
  const sidebar = document.getElementById("mcSidebar");
  if (!sidebar) return;

  const titleEl = document.getElementById("mcSidebarTitle");
  const bodyEl = document.getElementById("mcSidebarBody");

  const open = (title, html) => {
    titleEl.textContent = title || "Details";
    bodyEl.innerHTML = html || "";
    sidebar.classList.add("is-open");
    sidebar.setAttribute("aria-hidden", "false");
    document.body.classList.add("mc-sidebar-lock");
  };

  const close = () => {
    sidebar.classList.remove("is-open");
    sidebar.setAttribute("aria-hidden", "true");
    document.body.classList.remove("mc-sidebar-lock");
  };

  // Close triggers
  sidebar.querySelectorAll("[data-mc-sidebar-close]").forEach((el) => {
    el.addEventListener("click", close);
  });

  // ESC to close
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && sidebar.classList.contains("is-open")) close();
  });

  // Open triggers anywhere on page
  document.addEventListener("click", (e) => {
    const trigger = e.target.closest("[data-mc-sidebar-open]");
    if (!trigger) return;

    e.preventDefault();

    const title = trigger.getAttribute("data-mc-sidebar-title") || trigger.textContent.trim();
    const target = trigger.getAttribute("data-mc-sidebar-target");

    // Option A: pull content from a hidden template on the page
    if (target) {
      const tpl = document.querySelector(target);
      if (tpl) {
        open(title, tpl.innerHTML);
        return;
      }
    }

    // Option B: inline HTML via attribute
    const html = trigger.getAttribute("data-mc-sidebar-html");
    open(title, html);
  });
})();
